<div class="tiny-padding-all row-container">

  <span class="file-name padding-left">{{file.fileName}}</span>
  @if (canDeleteFile()) {
    <button type="button" class="minor-margin-right" attr.aria-label="Delete file '{{file.fileName}}'" (click)="deleteFile()">
      <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
    </button>
  }
  <button type="button" attr.aria-label="Download file '{{file.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile()">
    <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
  </button>
  <div class="progress-bar tiny-padding-all">
    <div class="progress no-margin" role="progressbar" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-meter" [ngStyle]="{ 'width': file.percentage + '%' }"></div>
    </div>
  </div>

</div>
<a style="display:none" href="" target="_blank" #downloadLink></a>
